import {OnSuccessData} from "../store/action/actionHelpers";
import {api} from "../api/api";
import Toast from "../components/helper/Toast";
import Attachment from "../model/attachment/Attachment";
import {none} from "ts-option";

/**
 * Asset uploader helper.
 */
export default class AssetUploadHelper {

	/**
	 * Upload file api call.
	 * @param {File} file File to upload
	 */
	private static uploadFile(file: File) {
		return api.instance.attachmentApi.uploadFile(file);
	}

	/**
	 * Uploads given assets and uses callbacks to reject a file.
	 * Calls onUploadSuccess with array of attachment identifiers on finishing all uploads.
	 * @param {File[]} files Array of files to upload
	 * @param {(file: File) => void} onRejectFile Triggered on file being rejected.
	 * @param {OnSuccessData<string[]>} onUploadSuccess Triggered on finishing all uploads.
	 */
	public static UploadAssets(files: File[], onRejectFile: (file: File) => void, onUploadSuccess: OnSuccessData<string[]>) {
		let promises: Promise<string | null>[] = files.map(file => {
			return this.uploadFile(file).catch((err) => {
				onRejectFile(file);
				Toast.error("Sorry, something went wrong. Try again later.",
					`Upload file: ${file.name}`);
				return Promise.reject(err);
			});
		});
		Promise.all(promises).then(ids => {
			onUploadSuccess(ids.filter(i => i));
		})
	}

	/**
	 * Uploads given files mixed with attachments and keep input order.
	 * @param {File | Attachment)[]} files Array of files and attachments
	 */
	public static uploadAssetFilesAndAttachments(files: (File | Attachment)[]): Promise<Attachment[]> {
		return new Promise(((resolve, reject) => {
			let promises: any[] = [];
			files.map(f => {
				if (f instanceof File) {
					promises.push(this.uploadFile(f));
				}
			});
			if (promises.length > 0) {
				const attachments: Attachment[] = [];
				Promise.all(promises)
					.then((attIds: string[]) => {
						let index = 0;
						files.forEach(f => {
							if (f instanceof File) {
								attachments.push(new Attachment(attIds[index++], f.name, none, none, none))
							}
							else {
								attachments.push(f)
							}
						})
						resolve(attachments);
					})
					.catch(reject);
			}
			else {
				resolve(files as Attachment[]);
			}
		}))
	}
}